import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import styles from 'styles/components/RgbButton.module.scss';

const RgbButton = ({
  text,
  textColor,
  backgroundColor,
  border,
  borderColor,
  pulse,
  icon,
  handleOnClick,
  rounded,
}) => (
  <motion.div
    onClick={handleOnClick ? handleOnClick : ''}
    animate={{ scale: pulse ? 1.05 : 1 }}
    transition={{ duration: 1.5, yoyo: pulse ? Infinity : '' }}
    className={styles.button}
    style={{
      width: pulse ? '98%' : '100%',
      backgroundColor,
      border: border ? `1px solid ${borderColor}` : '',
      borderRadius: rounded ? 25 : 5,
    }}
  >
    <span style={{ color: textColor }}>{text} </span>{' '}
    {icon && <div className={styles.icon}>{icon}</div>}
  </motion.div>
);

RgbButton.propTypes = {
  text: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  borderColor: PropTypes.string,
  border: PropTypes.bool,
  pulse: PropTypes.bool,
  icon: PropTypes.node,
  rounded: PropTypes.bool,
  handleOnClick: PropTypes.func,
};

RgbButton.defaultProps = {
  text: 'Button',
  backgroundColor: 'rgb(91, 0, 219)',
  textColor: 'rgb(255, 255, 255)',
  borderColor: '',
  border: false,
  pulse: false,
  rounded: true,
  icon: '',
  handleOnClick: () => {},
};

export default RgbButton;
